import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import CombineLedger from "../../../Components/ReportTables/CombineLedger";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import { Partner_Reports } from "../../../Configuration/Partner_URL";

function CombineLedgerReportNew() {
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const storeToken = localStorage.getItem("ssoToken");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");
  const [fileType, setFileType] = useState("grid");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [flag, setFlag] = useState("voucherDate");
  const [gridVal, setGridVal] = useState([]);
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [error, setError] = useState("");
  const [noReportFound, setNoReportFound] = useState(false);
  const [voucherType,setVoucherType]=useState([])
  const [exchangeType,setExchangeType]=useState([])
  const [reportType, setReportType] = useState([])
  const [voucher,setVoucher]=useState("")
  const [exchange,setExchange]=useState("")
  const [report,setReport]=useState("")
  const ClientId2 = localStorage.getItem("ClientId2");


  if (fromDate == "" || toDate == "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }
 

  const getExchangeType=async()=>{
    try {
      const getDetails = await axios.get(
        Dashboard_Client_Report.Get_ExchangeType
     ,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      console.log("getDetails",response)
      if(response?.status==0){
        setExchangeType(response?.data)
      }
      else{
        setExchangeType([])
      }
    }catch (error) {
      console.error(error)
    }
  }
 
  const getVoucherType=async()=>{
    try {
      const getDetails = await axios.get(
        Dashboard_Client_Report.Get_VoucherType,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      console.log("getVoucher",response)
      if(response.status==0){
        setVoucherType(response?.data)
      }
     
    }catch (error) {
      console.error(error)
    }
  }
  const getReportType = async () => {
    try {
      const getDetails = await axios.get(Dashboard_Client_Report.Get_ReportType,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
      console.log("getVoucher", response)
      if (response.status == 0) {
        setReportType(response?.data)
      }

    } catch (error) {
      console.error(error)
    }
  }

  useEffect(()=>{
    if(userType != "partner" && partnerRoleNew != "Partner"){
      getExchangeType()
      getVoucherType()
      getReportType()
      }
  },[])

  let clientCode = "";

  const getCombineLedgerReport = async (clientCode) => {
    setLoader(fileType === "grid");
    setSmallLoaderExcel(fileType === "excel");
    setSmallLoaderPdf(fileType === "pdf");
    setSmallLoaderMail(fileType === "mail");

    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      selectBy: flag,
      voucherType:voucher,
      exchangeType:exchange,
      reportType:report
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.CombineLedgerReport_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${partnerRoleNew === "Partner" ? partnerSsoToken : storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getDetails?.data);
          console.log("response combine",response)
      if (response?.status === 0) {
        setNoReportFound(false);
        if (fileType === "grid") {
          setGridVal(response?.data?.combine);
        } else if (fileType === "excel") {
          window.open(response?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(response?.data, "_blank", "noopener,noreferrer");
        } else if (fileType === "mail") {
          toast.success("Mail sent successfully");
        }
      } else {
        if (fileType !== "grid") {
          toast.error(response?.message);
        } else {
          setGridVal([]);
          setNoReportFound(response?.message);
        }
      }
    } catch (error) {
      console.error(error);
      setNoReportFound(error?.message);
      if (fileType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setGridVal([]);
    setError("");
    setFileType("");
    setNoReportFound(false);
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setGridVal([]);
    setError("");
    setFileType("");
    setNoReportFound(false);
  };

  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (fileType !== "") {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getCombineLedgerReport(clientCode);
        } else {
          setGridVal([]);
        }
      }
      // setFileType("");
    }
  }, [fileType]);

  const handleOnClick = (e) => {
    if (fromDate.length > 0 && toDate.length > 0) {
      if (e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          setFileType(e.target.value);
          setError("");
        } else {
          setFileType("grid");
          setError("Please Select Correct Date.");
        }
      }
    }
  };
  const handleOnChange = (e) => {
    if (e.target.value) {
      setFlag(e.target.value);
    }
    setFileType("");
    setGridVal([]);
    setNoReportFound(false);
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");


  const handleVoucherChange=(e)=>{
console.log("e.target.value",e.target.value)
    if(e.target.value){
      setVoucher(e.target.value)
    }
    else{
      setVoucher("")
    }
    setFileType("");
    setGridVal([]);
    setNoReportFound(false);
  }
  const handleExchangeChange=(e)=>{
    if(e.target.value){
    setExchange(e.target.value)
    }
    else{
      setExchange("")
    }
    setFileType("");
    setGridVal([]);
    setNoReportFound(false);
}
const handleReportChange = (e) => {
  if (e.target.value) {
    setReport(e.target.value)
  }
  else {
    setReport("")
  }
  setFileType("");
  setGridVal([]);
  setNoReportFound(false);
}

// console.log(typeof(new Number(10)),"hellooo")
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="combine-ledger"
        role="tabpanel"
        aria-labelledby="combine-ledger"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="d-flex">
                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="voucherDate"
                    defaultChecked="checked"
                    onChange={handleOnChange}
                  />
                  <label>{Constants.Voucher_Date}</label>
                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="effectiveDate"
                    onChange={handleOnChange}
                  />
                  <label>{Constants.Effective_Date}</label>
                </div>
                <div className="d-flex">
                  <FromdateComponent
                    fromDate={handleFromDateChange}
                    formatDate={formatDate(fromDate)}
                    DateReverse={DateReverse}
                  />

                  <TodateComponent
                    toDate={handleToDateChange}
                    formatToDate={formatDate(toDate)}
                    DateReverse={DateReverse}
                    errorResponse={error}
                  />
                </div>
                <div className="combineselect">
                  {userType !="partner" && partnerRoleNew != "Partner" ?
                <div className="form-group">
                <label className="form-label">{Constants.Voucher_Type}</label>
                <select

                  className="report-custom-select" 
                  onChange={handleVoucherChange}        
                >
                  <option value="">
                     Select 
                  </option>
               {voucherType.map((item)=>{
                return(
                <option value={item?.name}>{item?.value}</option>
                  )})}
                  

                </select>
              </div>
              : null
}
              {userType != "partner" && partnerRoleNew != "Partner" ?
              <div className="form-group">
                <label className="form-label">{Constants.Exchange}</label>
                <select
                  className="report-custom-select"   
                  onChange={handleExchangeChange}      
                >
                  <option value="">
                     Select
                  </option>
               {exchangeType.map((item,index)=>{
                return(
                <option key={index} value={item?.value}>{item?.name}</option>
                  )})}
                  

                </select>
              </div>
              : null}
              {userType != "partner" && partnerRoleNew != "Partner" ?
              <div className="form-group">
                <label className="form-label">{Constants.Report_Type}</label>
                <select
                  className="report-custom-select"
                  onChange={handleReportChange}
                >
                  <option value="">
                    Select
                  </option>
                  {reportType.map((item, index) => {
                    return (
                      <option key={index} value={item?.value}>{item?.name}</option>
                    )
                  })}


                </select>
              </div>
              :
              null}

              </div>
              </div>
              
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {/* <span class="icon-pdfsvg"></span> */}

              {Constants.Submit}
            </button>
          </div>
          {/* <form>
          
          </form> */}

          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                // <div>
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>

            <button
              className="generate-button excel-btn"
              value="excel"
              onClick={handleOnClick}
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : gridVal && gridVal.length > 0 ? (
        <div>
          <CombineLedger gridVal={gridVal} />
        </div>
      ) : (
        noReportFound && (
          <h4 className="report-error-message">{noDataFound(noReportFound)}</h4>
        )
      )}
    </>
  );
}
export default CombineLedgerReportNew;
